<template>
  <svg xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 16 16" fill="currentColor" width="24px">
    <path
      d="M4 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H4zm0 1h8a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1z"
    />
    <path
      d="m 8.98904,8.0004469 c 0,0.2761424 0.2238576,0.5 0.5,0.5 h 1.803513 l -1.147,1.146 c -0.4718872,0.4720001 0.236113,1.1800001 0.708,0.7080001 l 2,-2.0000001 c 0.195858,-0.1953639 0.195858,-0.5126361 0,-0.708 l -2,-2 c -0.472,-0.4719998 -1.1799998,0.2360002 -0.708,0.708 l 1.147,1.146 H 9.48904 c -0.2761424,0 -0.5,0.2238576 -0.5,0.5 z"
    />
    <path
      d="m 7.000446,8.0004469 c 0,0.2761424 -0.223857,0.5 -0.5,0.5 H 4.696933 l 1.147,1.146 C 6.315821,10.118447 5.60782,10.826447 5.135933,10.354447 L 3.1359335,8.3544469 c -0.195858,-0.1953639 -0.195858,-0.5126361 0,-0.708 l 1.9999995,-2 c 0.472,-0.4719998 1.18,0.2360002 0.708,0.708 l -1.147,1.146 h 1.803513 c 0.276143,0 0.5,0.2238576 0.5,0.5 z"
    />
  </svg>
</template>
